import { Button } from "react-bootstrap";
import {Fragment } from 'react'
import { useNavigate } from "react-router";

function CreatePaymentLinkButton()
{
    const navigate = useNavigate();

    function handleClick() {
      navigate("/create-payment-link")
    }

    return  <Fragment><Button variant="primary"  onClick={handleClick}>Create Payment Link</Button>
  
    </Fragment>

}

export default CreatePaymentLinkButton;